import { render, staticRenderFns } from "./homeworkAnalysis.vue?vue&type=template&id=3e52caad&scoped=true&"
import script from "./homeworkAnalysis.vue?vue&type=script&lang=js&"
export * from "./homeworkAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./homeworkAnalysis.vue?vue&type=style&index=0&id=3e52caad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52caad",
  null
  
)

export default component.exports